import { StatusOption } from '../../utils'

export enum MedicalConditionEnum {
  RAS = 'RAS',
  LEVEL_0 = 'LEVEL_0',
  LEVEL_1 = 'LEVEL_1',
  LEVEL_2 = 'LEVEL_2'
}

export const medicalConditionEnumMapping: Record<MedicalConditionEnum, StatusOption> = {
  [MedicalConditionEnum.RAS]: { label: 'RAS', variant: 'grey' },
  [MedicalConditionEnum.LEVEL_0]: { label: 'Niveau 0', variant: 'success' },
  [MedicalConditionEnum.LEVEL_1]: { label: 'Niveau 1', variant: 'warning' },
  [MedicalConditionEnum.LEVEL_2]: { label: 'Niveau 2', variant: 'danger' }
}

export const medicalConditionIndicatorEnumMapping: Record<MedicalConditionEnum, StatusOption> = {
  [MedicalConditionEnum.RAS]: { label: 'RAS', variant: 'success' },
  [MedicalConditionEnum.LEVEL_0]: { label: 'Niveau 0', variant: 'success' },
  [MedicalConditionEnum.LEVEL_1]: { label: 'Niveau 1', variant: 'warning' },
  [MedicalConditionEnum.LEVEL_2]: { label: 'Niveau 2', variant: 'warning' }
}
